<template>
  <router-link :to="to? to:'/'"
     :target="target"
    :class="[
      'el-button',
      this.type ? 'el-button--'+this.type : 'el-button--default',
      {
        ['el-button--'+this.size]: this.size,
        'is-plain': this.plain == '',
        'is-circle': this.circle == '',
        'is-round': this.round == ''
      }]">
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    props: ['to', 'size', 'type', 'round', 'circle', 'plain', 'target'],

    mounted() {
    }
  }
</script>
